import type { GalleryItem } from '../types/content'

// Immagini fornite dalla proprietaria per entrambi i caroselli.
export const tricotinGallery: GalleryItem[] = [
  {
    id: 'g1',
    motif: 'portachiavi cuore',
    src: 'https://cdn.magicpatterns.com/uploads/33xufjKsmo8e4oBws4w6UC/image.png',
    alt: 'Mano che mostra un portachiavi a cuore in tricotin sfumato rosa, lilla e menta con perline del nome Isabelle, davanti a tanti portachiavi uguali',
  },
  {
    id: 'g2',
    motif: 'fiori bomboniera',
    src: 'https://cdn.magicpatterns.com/uploads/d5LAtcVCSQ73EnE2NiNZu7/image.png',
    alt: 'Bomboniere con margherite, un sole e un arcobaleno in tricotin pastello su basi di legno, con cartellini e nastri',
  },
  {
    id: 'g3',
    motif: 'nome cerchio',
    src: 'https://cdn.magicpatterns.com/uploads/vJ1Do53efDjLxKgnYupA3R/image.png',
    alt: 'Nome Gabriel in tricotin azzurro su un cerchio di legno appeso, con palloncini e un coniglietto su un’altalena',
  },
  {
    id: 'g4',
    motif: 'arcobaleno nome',
    src: 'https://cdn.magicpatterns.com/uploads/jmnGN8YBjVBGtTS9VnHsRn/image.png',
    alt: 'Arcobaleno in tricotin viola, rosa e bianco con pompon e il nome Emma in cordoncino lilla',
  },
  {
    id: 'g5',
    motif: 'nome macchinina',
    src: 'https://cdn.magicpatterns.com/uploads/9ZxxQzDMeeVej9vBnCZNCg/image.png',
    alt: 'Nome Oliver e una macchinina in tricotin blu dentro una cornice circolare intrecciata color crema',
  },
  {
    id: 'g7',
    motif: 'iniziale in cornice',
    src: 'https://cdn.magicpatterns.com/uploads/2ZWQKGAoYiHKAPJ1FGu8tU/image.png',
    alt: 'Due cornici bianche con una lettera M e un arcobaleno in tricotin rosa su fondo di pizzo',
  },
  {
    id: 'g8',
    motif: 'numeri cake topper',
    src: 'https://cdn.magicpatterns.com/uploads/xsZeopAu2rqfpPsU4ERmF2/image.png',
    alt: 'Numeri 1, 8 e 3 in tricotin rosa con fiocchi beige, confezionati su cartoncini kraft',
  },
  {
    id: 'g9',
    motif: 'cuori cake topper',
    src: 'https://cdn.magicpatterns.com/uploads/1WgBpZGBZfFUQATSv53iHa/image.png',
    alt: 'Mano che tiene un cake topper con due cuori in tricotin verde salvia e azzurro e un fiocco blu',
  },
  {
    id: 'g10',
    motif: 'orsetto',
    src: 'https://cdn.magicpatterns.com/uploads/8bTtt4LLosjk2AHi3T6LBH/image.png',
    alt: 'Mano che tiene una sagoma di orsetto in tricotin color crema con tutù di tulle rosa e naso a pompon',
  },
  {
    id: 'g11',
    motif: 'natale',
    src: 'https://cdn.magicpatterns.com/uploads/3yofmPmLdgrwrNRREA1W7s/image.png',
    alt: 'Decorazioni natalizie in tricotin: bastoncino di zucchero, casetta di pan di zenzero, omino, alberelli, busta, pacchetto regalo e la scritta ho',
  },
  {
    id: 'g12',
    motif: 'coniglietto pasquale',
    src: 'https://cdn.magicpatterns.com/uploads/cUnQDcMpjaxXMwoTigD7TF/image.png',
    alt: 'Ghirlanda a forma di uovo in tricotin verde salvia con un coniglietto giallo senape e fiori rosa',
  },
]
